// extracted by mini-css-extract-plugin
export default {"right_article":"index_right_article_wqsW0","first_item":"index_first_item_AqBIG","item":"index_item_vbIyP","check_more":"index_check_more_M4AV4","assess":"index_assess_yKRJH"};